//==
//== Main body script
//== ======================================= ==//

$('.scroll-arrow').on('click', function (e) {
    e.preventDefault();

    if ($('.promo-block').length) {
 $('html, body').animate({
        scrollTop: $('.promo-block').offset().top,
    }, 700);
 }

    if ($('.composite-section').length) {
 $('html, body').animate({
        scrollTop: $('.composite-section').offset().top,
    }, 700);
}
});
